module.exports = __webpack_public_path__ + "static/media/wells-fargo.77798dd6.png";